import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from "../Footer";
import axios from "axios";
import DataTable from "react-data-table-component";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonTable, SkeletonCard } from "../components/SkeletonLoader";
import { BtnLoader } from "../components/PageLoader";
import CarCard from "../components/CarCard";
const MyInventory = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [viewMode, setViewMode] = useState("card");
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [loadingBulkPublish, setLoadingBulkPublish] = useState(false);
  const [loadingBulkUnpublish, setLoadingBulkUnpublish] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    // Restore document scrollbar in case it was hidden by unmounted modals/Swal
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
    document.documentElement.style.overflow = "auto";
    document.documentElement.style.height = "auto";
    document.body.classList.remove("modal-open");
    document.body.classList.remove("swal2-shown");
    document.body.classList.remove("swal2-height-auto");
  }, []);

  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  const formatNumber = (num) => {
    if (num >= 10000000) {
      return (num / 10000000).toFixed(1) + "M";
    } else if (num >= 100000) {
      return (num / 100000).toFixed(1) + "L";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K";
    } else {
      return num.toString();
    }
  };
  function convertCcToLiters(cc) {
    if (cc > 0) {
      return (cc / 1000).toFixed(1);
    } else {
      return 0;
    }
  }
  const getAllMyCar = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/cars/all-mylist",
        {
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        setData(response?.data?.data);
        // console.log(response?.data?.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    getAllMyCar();
  }, []);

  const deleteMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/car/delete",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        getAllMyCar();
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const editMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/edit/mycar",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        navigate("/dealer/edit-cars", { state: { data: response?.data?.data } });
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const handleDelete = (id) => {
    const userConfirmed = window.confirm(
      "are you sure you want to delete the car data ?"
    );
    if (userConfirmed) {
      deleteMyCar(id);
    }
  };
  function backto() {
    window.history.back();
  }

  const updateCarStatus = async (id, status) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/car/publish-and-unpublish",
        {
          car_ids: [id],
          status: status,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        getAllMyCar();
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while updating status.", error);
    }
  };

  const publishMyCar = (id) => {
    updateCarStatus(id, 1);
  };

  const unpublishMyCar = (id) => {
    updateCarStatus(id, 0);
  };

  const updateManyCarStatus = async (ids, status, setLoading) => {
    try {
      if (setLoading) {
        setLoading(true);
      }
      const response = await axios.post(
        window.CARLOCA_API + "/car/publish-and-unpublish",
        {
          car_ids: ids,
          status: status,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        if (setLoading) {
          setLoading(false);
        }
        setSelectedRowIds([]);
        setStatusFilter("all");
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            status === 1
              ? "Selected cars have been published."
              : "Selected cars have been unpublished.",
          confirmButtonColor: "#00889C",
        });
        getAllMyCar();
      } else {
        if (setLoading) {
          setLoading(false);
        }
        alert(response?.data?.message);
      }
    } catch (error) {
      if (setLoading) {
        setLoading(false);
      }
      console.log("An error occurred while updating status.", error);
    }
  };

  const bulkDeleteCars = async (ids) => {
    try {
      for (const id of ids) {
        await axios.post(
          window.CARLOCA_API + "/car/delete",
          {
            car_id: id,
            owner_id: storedUserPreferences?.id,
          }
        );
      }
      getAllMyCar();
    } catch (error) {
      console.log("An error occurred while deleting cars.", error);
    }
  };

  const handleBulkPublish = () => {
    if (!selectedRowIds.length) {
      Swal.fire({
        icon: "warning",
        title: "No cars selected",
        text: "Please select at least one car to publish.",
        confirmButtonColor: "#00889C",
      });
      return;
    }
    updateManyCarStatus(selectedRowIds, 1, setLoadingBulkPublish);
  };

  const handleBulkUnpublish = () => {
    if (!selectedRowIds.length) {
      Swal.fire({
        icon: "warning",
        title: "No cars selected",
        text: "Please select at least one car to unpublish.",
        confirmButtonColor: "#00889C",
      });
      return;
    }
    updateManyCarStatus(selectedRowIds, 0, setLoadingBulkUnpublish);
  };

  const handleBulkDelete = () => {
    if (!selectedRowIds.length) return;
    const userConfirmed = window.confirm(
      "Are you sure you want to delete selected cars?"
    );
    if (userConfirmed) {
      bulkDeleteCars(selectedRowIds);
    }
  };

  const filteredData = data
    .filter((car) => {
      if (statusFilter === "published") {
        return car.status === 1;
      }
      if (statusFilter === "unpublished") {
        return car.status !== 1;
      }
      return true;
    })
    .filter((car) => {
      if (!filterText) return true;
      const text = filterText.toLowerCase();
      return (
        (car.make && car.make.toLowerCase().includes(text)) ||
        (car.model && car.model.toLowerCase().includes(text)) ||
        (car.body_type && car.body_type.toLowerCase().includes(text)) ||
        (car.color && car.color.toLowerCase().includes(text)) ||
        (car.year && String(car.year).toLowerCase().includes(text)) ||
        (car.registration_number &&
          String(car.registration_number).toLowerCase().includes(text))
      );
    });

  const columnsData = [
    {
      name: "Make",
      selector: (row) => row.make,
      sortable: true,
    },
    {
      name: "Model",
      selector: (row) => row.model,
      sortable: true,
    },
    {
      name: "Year",
      selector: (row) => row.year,
      sortable: true,
      width: "80px",
    },
    {
      name: "Colour",
      selector: (row) => row.color,
      width: "80px",
    },
    {
      name: "Body Type",
      selector: (row) => row.body_type,
    },
    {
      name: "Price",
      selector: (row) => formatNumber(row.offer_price),
      width: "80px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`badge ${row.status === 1 ? "bg-success rounded-0" : "bg-danger rounded-0"
            }`}
        >
          {row.status === 1 ? "Published" : "Unpublished"}
        </span>
      ),
      width: "90px",
    },
    {
      name: "Preview",
      cell: (row) => (
        <Link
          to={`/cardetails?car=${row?.slug}`}
          className="btn btn-sm btn-outline-light p-0 text-dark"
          style={{ fontSize: 12 }}
        >
          Click Here
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "80px",
    },
    {
      name: "Edit",
      cell: (row) => (
        <button
          onClick={() => editMyCar(row?.id)}
          className="btn btn-sm"
          type="button"
        >
          <i className="fa fa-edit"></i>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
    },
    {
      name: "Delete",
      cell: (row) => (
        <button
          onClick={() => handleDelete(row.id)}
          className="btn text-danger btn-sm"
        >
          <i className="fa fa-trash"></i>
        </button>
      ),
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleSelectedRowsChange = ({ selectedRows }) => {
    const ids = selectedRows.map((row) => row.id);
    setSelectedRowIds(ids);
  };
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container-fluid px-3 px-md-4">
          <div className="d-flex align-items-center justify-content-between w-100 mb-3 flex-wrap gap-2">
            <div>
              <h3 className="cl-page-title">My Inventory</h3>
              <p className="cl-page-subtitle">Manage your car inventory</p>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
                <i className="fa fa-arrow-left"></i>Back
              </button>
              <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-primary cl-btn-sm">
                <i className="fa-solid fa-plus me-1"></i>Add Car
              </Link>
              <Link to="/dealer/bulk-upload-cars" className="cl-btn cl-btn-outline cl-btn-sm">
                <i className="fa-solid fa-file-csv me-1"></i>Bulk Upload CSV
              </Link>
              <button type="button" className="cl-btn cl-btn-outline cl-btn-sm" onClick={() => setViewMode(viewMode === "card" ? "table" : "card")}>
                {viewMode === "card" ? "Table View" : "Card View"}
              </button>
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-between w-100 mb-3 gap-2">
            <div className="d-flex align-items-center">
              <label className="me-2 mb-0 fw-medium">Status:</label>
              <select className="cl-form-control" style={{ width: "160px" }} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                <option value="unpublished">Unpublished</option>
                <option value="published">Published</option>
                <option value="all">All</option>
              </select>
            </div>
            <div>
              <input type="text" placeholder="Search by make, model..." value={filterText} onChange={(e) => setFilterText(e.target.value)} className="cl-form-control" style={{ minWidth: "220px" }} />
            </div>
          </div>
          {pageLoading ? (
            viewMode === "table" ? <SkeletonTable /> : <SkeletonCard count={8} />
          ) : viewMode === "table" ? (
            <div className="cl-card">
              <div className="cl-card-body">
                {data.length === 0 ? (
                  <div className="cl-empty">
                    <div className="cl-empty-icon"><i className="fa-solid fa-car"></i></div>
                    <h6 className="cl-empty-title">No Cars Found</h6>
                    <p className="cl-empty-text">Your inventory is empty.</p>
                  </div>
                ) : (
                  <>
                    <div className="d-flex flex-wrap mb-2 gap-2">
                      <button type="button" className="cl-btn cl-btn-outline cl-btn-sm" onClick={handleBulkUnpublish} disabled={loadingBulkUnpublish}>
                        {loadingBulkUnpublish ? <><BtnLoader /> Processing...</> : "Unpublish Selected"}
                      </button>
                      <button type="button" className="cl-btn cl-btn-primary cl-btn-sm" onClick={handleBulkPublish} disabled={loadingBulkPublish}>
                        {loadingBulkPublish ? <><BtnLoader /> Processing...</> : "Publish Selected"}
                      </button>
                      <button type="button" className="cl-btn cl-btn-danger cl-btn-sm" onClick={handleBulkDelete}>Delete Selected</button>
                    </div>
                    <DataTable
                      columns={columnsData}
                      data={filteredData}
                      selectableRows
                      onSelectedRowsChange={handleSelectedRowsChange}
                      pagination
                      responsive
                      fixedHeader
                      highlightOnHover
                    />
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="row">
              {data.length === 0 ? (
                <div className="cl-empty">
                  <div className="cl-empty-icon"><i className="fa-solid fa-car"></i></div>
                  <h6 className="cl-empty-title">No Cars Found</h6>
                  <p className="cl-empty-text">Your inventory is empty.</p>
                </div>
              ) : (
                <>
                  {data.length > 0 && selectedRowIds.length > 0 && (
                    <div className="col-12 mb-3">
                      <div className="d-flex flex-wrap bg-white p-3 border rounded shadow-sm align-items-center gap-2">
                        <span className="me-3 fw-bold">{selectedRowIds.length} car(s) selected</span>
                        <button type="button" className="cl-btn cl-btn-outline cl-btn-sm" onClick={handleBulkUnpublish} disabled={loadingBulkUnpublish}>
                          {loadingBulkUnpublish ? "Processing..." : "Unpublish Selected"}
                        </button>
                        <button type="button" className="cl-btn cl-btn-primary cl-btn-sm" onClick={handleBulkPublish} disabled={loadingBulkPublish}>
                          {loadingBulkPublish ? "Processing..." : "Publish Selected"}
                        </button>
                        <button type="button" className="cl-btn cl-btn-danger cl-btn-sm" onClick={handleBulkDelete}>
                          Delete Selected
                        </button>
                      </div>
                    </div>
                  )}
                  {filteredData.map((car) => (
                    <div
                      key={car.id}
                      className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                    >
                      <CarCard
                        carData={car}
                        linkTo={`/dealer/saved/car/detail?car=${car?.slug}`}
                        topLeftContent={
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#00889c" }}
                              checked={selectedRowIds.includes(car.id)}
                              onChange={(e) => {
                                e.stopPropagation();
                                if (e.target.checked) {
                                  setSelectedRowIds([...selectedRowIds, car.id]);
                                } else {
                                  setSelectedRowIds(selectedRowIds.filter(id => id !== car.id));
                                }
                              }}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <button
                              className="btn btn-sm btn-danger"
                              style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(car.id); }}
                            >
                              <i className="fa fa-trash" style={{ color: "white", fontSize: "13px" }}></i>
                            </button>
                          </div>
                        }
                        topRightContent={
                          <button
                            className="btn btn-sm btn-primary"
                            style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); editMyCar(car.id); }}
                          >
                            <i className="fa fa-edit" style={{ color: "white", fontSize: "13px" }}></i>
                          </button>
                        }
                        extraBodyContent={
                          <div className="d-flex justify-content-between align-items-center mt-2 pt-2" style={{ borderTop: "1px solid #eee" }}>
                            <span
                              className="badge"
                              style={{
                                backgroundColor: car.status === 1 ? "#28a745" : "#dc3545",
                                color: "#fff",
                                fontSize: "10px",
                                padding: "4px 10px",
                                borderRadius: "6px",
                              }}
                            >
                              {car.status === 1 ? "Published" : "Unpublished"}
                            </span>
                            <div>
                              {car.status === 1 ? (
                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  style={{ fontSize: "11px", color: "#e2a900", border: "1px solid #e2a900", borderRadius: "6px", padding: "2px 10px" }}
                                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); unpublishMyCar(car.id); }}
                                >
                                  Unpublish
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  style={{ fontSize: "11px", color: "#28a745", border: "1px solid #28a745", borderRadius: "6px", padding: "2px 10px" }}
                                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); publishMyCar(car.id); }}
                                >
                                  Publish
                                </button>
                              )}
                            </div>
                          </div>
                        }
                        hideFooter={true}
                      />
                    </div>
                  ))}
                </>
              )
              }
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MyInventory;
